import React from 'react'

const Social = () => {
    return (
        <div className="home_social">
            <a href="https://www.linkedin.com/in/serkan-dalgıç-37583b377/" className="home_social-icon" target="_blank" rel="noreferrer">
            <i class="uil uil-linkedin"></i>
            </a>

            {/* <a href="#" className="home_social-icon" target="_blank">
            <i class="uil uil-dribbble"></i>
            </a> */}

            <a href="https://github.com/srkngthb16" className="home_social-icon" target="_blank" rel="noreferrer">
            <i class="uil uil-github-alt"></i>
            </a>
        </div>
    )
}

export default Social